export const GET_INSTITUTIONS_TYPES = 'GET_INSTITUTIONS_TYPES';
export const TAXONOMIES_LOADING = 'TAXONOMIES_LOADING';

export const INSTITUTIONS_DETAILS_REQUEST = 'INSTITUTIONS_DETAILS_REQUEST';
export const INSTITUTIONS_DETAILS_SUCCESS = 'INSTITUTIONS_DETAILS_SUCCESS';
export const INSTITUTIONS_DETAILS_FAILURE = 'INSTITUTIONS_DETAILS_FAILURE';

// Institutions list for the dropdown
export const INSTITUTIONS_DROPDOWN_REQUEST = 'INSTITUTIONS_DROPDOWN_REQUEST';
export const INSTITUTIONS_DROPDOWN_FAILURE = 'INSTITUTIONS_DROPDOWN_FAILURE';
export const INSTITUTIONS_DROPDOWN_SUCCESS = 'INSTITUTIONS_DROPDOWN_SUCCESS';

export const INSTITUTIONS_LIST_REQUEST = 'INSTITUTIONS_LIST_REQUEST';
export const INSTITUTIONS_LIST_SUCCESS = 'INSTITUTIONS_LIST_SUCCESS';
export const INSTITUTIONS_LIST_FAILURE = 'INSTITUTIONS_LIST_FAILURE';

export const SET_INSTITUTIONS_SEARCH_CRITERIA = 'SET_INSTITUTIONS_SEARCH_CRITERIA';
export const RESET_INSTITUTIONS_SEARCH_CRITERIA = 'RESET_INSTITUTIONS_SEARCH_CRITERIA';
export const TOGGLE_DRAWER_MOBILE_FILTER_SEARCH = 'TOGGLE_DRAWER_MOBILE_FILTER_SEARCH';

export const INSTITUTIONS_TYPES_REQUEST = 'INSTITUTIONS_TYPES_REQUEST';
export const INSTITUTIONS_TYPES_SUCCESS = 'INSTITUTIONS_TYPES_SUCCESS';
export const INSTITUTIONS_TYPES_FAILURE = 'INSTITUTIONS_TYPES_FAILURE';

export const GET_INSTITUTIONS_AGES_REQUEST = 'GET_INSTITUTIONS_AGES_REQUEST';
export const GET_INSTITUTIONS_AGES_SUCCESS = 'GET_INSTITUTIONS_AGES_SUCCESS';
export const GET_INSTITUTIONS_AGES_FAILURE = 'GET_INSTITUTIONS_AGES_FAILURE';



// WEBPACK FOOTER //
// ./src/features/Institutions/types.js